export default [
  {
    title: 'Template set',
    type: 'SelectQuery',
    required: true,
    data: 'templateSets',
    dataIndex: 'template_set',
    fieldKey: 'template_set',
    selectedKey: 'pk',
    selectedValue: 'name',
    initialValue: '',
    note_text: '',
    additional: 'edit|add',
    editable: true,
    width: 250,
    order: 0,
  }, {
    title: 'Code',
    type: 'text',
    data: '',
    required: true,
    dataIndex: 'code',
    fieldKey: 'code',
    initialValue: '',
    note_text: '',
    additional: '',
    editable: true,
    // maxLength: '4',
    order: 1,
  }, {
    title: 'Name',
    type: 'text',
    data: '',
    required: true,
    dataIndex: 'name',
    fieldKey: 'name',
    initialValue: '',
    note_text: '',
    additional: '',
    editable: true,
    order: 2,
  }, {
    title: 'Status',
    type: 'select',
    fieldKey: 'status',
    disableAllowClear: true,
    data: [
      {
        alias: 'active',
        value: 'Active - Anyone can use'
      }, {
        alias: 'inactive',
        value: 'Inactive - No one can use'
      }, {
        alias: 'unpublished',
        value: 'Unpublished - Only certain people can use'
      }
    ],
    initialValue: 'active',
    note_text: '',
    dataIndex: 'status',
    editable: true,
    additional: '',
    order: 3,
  }, {
    title: 'Groups',
    type: 'select_multiple',
    data: 'productGroups',
    dataIndex: 'groups',
    initialValue: [],
    note_text: '',
    additional: 'add',
    // minSelected: 2,
    // maxSelected: 3,
    order: 4,
    selectedKey: 'pk',
    selectedValue: 'name',
  }, {
    title: 'Unit',
    type: 'SelectQuery',
    data: 'units',
    required: true,
    dataIndex: 'unit',
    fieldKey: 'unit',
    selectedKey: 'pk',
    selectedValue: 'name',
    initialValue: '',
    note_text: 'Unit of measurement for this product.',
    additional: 'edit|add',
    editable: true,
    order: 5,
  }, {
    title: 'For each',
    type: 'number',
    data: '',
    dataIndex: 'for_each',
    initialValue: '0',
    note_text: '',
    additional: '',
    // minValue: 5,
    // maxValue: 15,
    // isDecimal: true,
    // decimalPlaces: 4,
    order: 6,
  }, {
    title: 'Horizontal',
    type: 'number',
    dataIndex: 'horizontal',
    data: '',
    initialValue: '0',
    note_text: '',
    additional: '',
    fieldKey: 'horizontal',
    editable: true,
    // maxValue: 9,
    // isDecimal: true,
    order: 7,
  }, {
    title: 'Vertical',
    type: 'number',
    data: '',
    dataIndex: 'vertical',
    initialValue: '0',
    note_text: '',
    additional: '',
    // maxDecimal: 3,
    // isDecimal: true,
    // decimalPlaces: 3,
    fieldKey: 'vertical',
    editable: true,
    order: 8,
  }, {
    title: 'M2',
    type: 'number',
    data: '',
    dataIndex: 'm2',
    initialValue: '0',
    note_text: '',
    additional: '',
    // minValue: 10,
    fieldKey: 'm2',
    editable: true,
    order: 9,
  }, {
    title: 'M3',
    type: 'number',
    data: '',
    dataIndex: 'm3',
    initialValue: '0',
    note_text: '',
    additional: '',
    // minValue: 0,
    // maxValue: 1,
    // decimalPlaces: 10,
    fieldKey: 'm3',
    editable: true,
    order: 10,
  }, {
    title: 'Weight',
    type: 'number',
    data: '',
    dataIndex: 'weight',
    initialValue: '0',
    note_text: '',
    additional: '',
    fieldKey: 'weight',
    editable: true,
    order: 11,
  }, {
    title: 'Timber M3',
    type: 'number',
    data: '',
    dataIndex: 'timber_m3',
    initialValue: '0',
    note_text: '',
    additional: '',
    fieldKey: 'timber_m3',
    editable: true,
    order: 12,
  }, {
    title: 'Paint',
    type: 'number',
    dataIndex: 'paint',
    data: '',
    initialValue: '0',
    note_text: '',
    additional: '',
    fieldKey: 'paint',
    editable: true,
    order: 13,
  }, {
    title: 'Old Code',
    type: 'number',
    data: '',
    dataIndex: 'old_code',
    initialValue: '0',
    note_text: '',
    additional: '',
    fieldKey: 'old_code',
    editable: true,
    order: 14,
  }, {
    title: 'Fixings',
    type: 'number',
    data: '',
    dataIndex: 'fixings',
    initialValue: '0',
    note_text: '',
    additional: '',
    fieldKey: 'fixings',
    editable: true,
    order: 15,
  }, {
    title: 'Factor1',
    type: 'number',
    data: '',
    dataIndex: 'factor1',
    initialValue: '0',
    note_text: '',
    additional: '',
    fieldKey: 'factor1',
    editable: true,
    order: 16,
  }, {
    title: 'Factor2',
    type: 'number',
    data: '',
    dataIndex: 'factor2',
    initialValue: '0',
    note_text: '',
    additional: '',
    fieldKey: 'factor2',
    editable: true,
    order: 17,
  }, {
    title: 'Factor3',
    type: 'number',
    data: '',
    dataIndex: 'factor3',
    initialValue: '0',
    note_text: '',
    additional: '',
    fieldKey: 'factor3',
    editable: true,
    order: 18,
  }, {
    title: 'Factor4',
    type: 'number',
    data: '',
    dataIndex: 'factor4',
    initialValue: '0',
    note_text: '',
    additional: '',
    fieldKey: 'factor4',
    editable: true,
    order: 19,
  }, {
    title: 'Factor5',
    type: 'number',
    data: '',
    dataIndex: 'factor5',
    initialValue: '0',
    note_text: '',
    additional: '',
    fieldKey: 'factor5',
    editable: true,
    order: 20,
  }, {
    title: 'Each',
    type: 'number',
    data: '',
    dataIndex: 'each',
    initialValue: '0',
    note_text: '',
    additional: '',
    order: 21,
  }, {
    title: 'Group No',
    type: 'text',
    data: '',
    dataIndex: 'groupno',
    initialValue: '',
    note_text: '',
    additional: '',
    order: 22,
  }, {
    title: 'Group Code',
    type: 'text',
    data: '',
    dataIndex: 'gcode',
    initialValue: '',
    note_text: '',
    additional: '',
    order: 23,
  }, {
    title: 'Labour',
    type: 'number',
    data: '',
    dataIndex: 'labour',
    initialValue: '',
    note_text: '',
    additional: '',
    fieldKey: 'labour',
    editable: true,
    order: 24,
  }, {
    title: 'Labour Unit',
    type: 'SelectQuery',
    data: 'units',
    initialValue: '',
    dataIndex: 'labour_unit',
    selectedKey: 'pk',
    selectedValue: 'name',
    note_text: 'Unit of measurement for labour.',
    additional: 'edit|add',
    fieldKey: 'labour_unit',
    // editable: true,
    order: 25,
  }, {
    title: 'Supplier',
    type: 'text',
    data: '',
    dataIndex: 'supplier',
    initialValue: '',
    note_text: '',
    additional: '',
    fieldKey: 'supplier',
    editable: true,
    order: 26,
  }, {
    title: 'Import session',
    type: 'text',
    data: '',
    dataIndex: 'import_session',
    initialValue: '',
    note_text: '',
    additional: '',
    fieldKey: 'import_session',
    editable: true,
    order: 27,
  }, {
    title: 'Timber product',
    type: 'checkbox',
    data: '',
    dataIndex: 'timber_product',
    fieldKey: 'timber_product',
    initialValue: '',
    note_text: '',
    additional: '',
    editable: true,
    order: 28,
  }, {
    title: 'Special notes',
    type: 'text',
    data: '',
    dataIndex: 'special_notes',
    initialValue: '',
    note_text: '',
    additional: '',
    fieldKey: 'special_notes',
    editable: true,
    order: 29,
  }
];
